import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9222f34a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, "3. 注销极飞账号处理时限", -1))
const _hoisted_2 = { class: "content-sepc" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "15天内", -1))
const _hoisted_4 = { class: "footer xag-page__footer nongfu-button-wrap" }

import {} from 'vue'
import { Button } from 'vant'
import { useStore } from 'vuex'
import { applyCloseAccount } from '@/apis/close-account'
import { showToastLoading, showToastSuccess, showConfirmModal } from '@/utils/tools'
import appHost from '@/utils/app'
import AppHeader from '@/components/Header.vue'
import CommonContent from './components/common-content.vue'
import dayjs from 'dayjs'

export default /*#__PURE__*/_defineComponent({
  __name: 'confirm',
  setup(__props) {

const store = useStore()
const content = {
  title: '注销账号温馨提醒',
  infoList: [
    {
      label: '1. 注销极飞账号是不可恢复的操作',
      value:
        '您应自行备份极飞账号相关的信息和数据。操作之前，请确认与极飞账号相关的服务均已进行妥善处理。',
    },
    {
      label: '2. 注销极飞账号后无法再使用本账号登录极飞账号体系平台 ',
      value:
        '确认注销极飞账号后，您将无法再使用本账号登录极飞账号体系平台（包括但不限于：极飞农服App、极飞XPilot App、极飞服务小程序、极飞商城等）。',
    },
  ],
}
const endDate = dayjs(Date.now() + 24 * 60 * 60 * 1000 * 15).format('YYYY-MM-DD')
async function confirm() {
  try {
    await showConfirmModal({
      message: '是否确认注销?',
      className: 'repair-dialog',
    })
    showToastLoading()
    await applyCloseAccount({
      code: store.state.CloseAccount.code,
    })
    showToastSuccess('已提交注销申请，即将自动退出登录')
    setTimeout(() => {
      appHost.onLogin()
    }, 2000)
  } catch (error) {
    console.log('error', error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "注销账号" }),
    _createVNode(CommonContent, {
      data: content,
      showSlot: ""
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(" 确认注销，极飞将在"),
          _hoisted_3,
          _createTextVNode("（不含提交当天）审核您的申请，如符合注销条件，您的极飞账号将自"),
          _createElementVNode("span", null, _toDisplayString(_unref(endDate)), 1),
          _createTextVNode("起永久注销。注销后，本账号绑定的手机号将同时被释放，再次登录将会创建一个新的账号。 ")
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Button), {
        type: "success",
        onClick: confirm,
        block: "",
        round: "",
        class: "button xa-vant-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode("确认注销")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})